/**
 * Described gender field of patient record in DB
 */
export enum GENDER {
    MALE = 'MALE',
    FEMALE = 'FEMALE',
    OTHER = 'Non-binary',
}
